import React, { createContext, useMemo, useContext } from "react";

import type { ServerResponseContext } from "~/lib/server";

export interface ServerDataProviderProps {
  rootData: ServerResponseContext["rootData"];
  siteData: ServerResponseContext["siteLoaderData"];
  children: React.ReactNode;
}

interface ServerDataProviderContextType {
  rootData: ServerResponseContext["rootData"];
  siteData: ServerResponseContext["siteLoaderData"];
}

const ServerDataProviderContext =
  createContext<ServerDataProviderContextType | null>(null);

export function ServerDataProvider({
  children,
  rootData,
  siteData,
}: ServerDataProviderProps) {
  const value = useMemo<ServerDataProviderContextType>(
    () => ({ rootData, siteData }),
    [rootData, siteData],
  );

  return (
    <ServerDataProviderContext.Provider value={value}>
      {children}
    </ServerDataProviderContext.Provider>
  );
}

export function useServerDataContext() {
  return useContext(ServerDataProviderContext)!;
}
